document.addEventListener('turbolinks:load', () => {
  $('.select2-courses').select2();
  $('.select2-curriculums').select2();
  $('.select2-lessons').select2();
  $('.select2-tags').select2({
    tags: true
  });
});
